import React from 'react';
import { Assistant } from '@/types';
import { MessageContent } from './';
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';

interface StreamingMessageProps {
    content: string;
    assistant: Assistant;
}

export const StreamingMessage: React.FC<StreamingMessageProps> = ({ content, assistant }) => {
    return (
        <div className="flex gap-2 justify-start animate-fade-in">
            <div className="flex gap-2 max-w-[85%]">
                <div className="size-8 rounded-full flex items-center justify-center">
                    {renderAssistantIcon({
                        assistant,
                        size: 'md'
                    })}
                </div>
                <div className="px-2 py-1">
                    <MessageContent
                        content={content}
                        role="assistant"
                    />
                    <div className="mt-1 flex items-center gap-1">
                        <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse"></div>
                        <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse delay-75"></div>
                        <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse delay-150"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};